import * as React from 'react';
import {
    Dialog,
    DialogFooter,
    DialogType,
    IDialogContentStyles,
    IDialogContentStyleProps,
} from 'office-ui-fabric-react/lib/Dialog';
import FindPeopleControl from 'owa-readwrite-recipient-well-fabric/lib/components/FindPeopleControl';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import PeoplePickerPersona from './PeoplePickerPersona';
import strings from 'owa-strings/owa-mail-strings';
import store from '../store/store';
import { observer } from 'mobx-react';
import { populateUserMailboxInfo, onDismissed } from '../actions/internalActions';

let styles = require('./PeoplePickerDialog.scss');

// Properties for PeoplePickerDialog component
export interface PeoplePickerDialogProps {
    title: string;
    subTitle: string;
    addCallback: (userMailboxInfo: EmailAddressWrapper) => any;
    cancelCallback: () => any;
    hidden?: boolean; // Hide/show is now fully controlled by the consumer of this component.
}

@observer
export default class PeoplePickerDialog extends React.Component<PeoplePickerDialogProps, {}> {
    // Local instance which will be used to get ref and access clearInput public method of class FindPeopleControl
    private peoplePicker: FindPeopleControl = null;

    /**
     * Method to provide customized styling for subtext of the Dialog
     */
    private getContextStyle(props: IDialogContentStyleProps): IDialogContentStyles {
        return {
            subText: [
                {
                    fontSize: '14px',
                    fontWeight: '400',
                },
            ],
        } as IDialogContentStyles;
    }

    /**
     * Callback method to be called when PeoplePicker item is clicked, it clears the input also
     */
    private onPersonSelected = (item: FindRecipientPersonaType) => {
        this.peoplePicker.clearInput();
        const mailbox = item.EmailAddress as EmailAddressWrapper;
        populateUserMailboxInfo(mailbox);
    };

    /**
     * Method for add callback
     */
    private onAddClick = () => {
        this.props.addCallback(store.userMailboxWrapper);
        this.closeDialog();
    };

    /**
     * Method for close dialog box callback
     */
    private closeDialog = () => {
        this.props.cancelCallback();
        onDismissed();
    };

    /**
     * Method for remove persona callback
     */
    private removePerson = () => {
        populateUserMailboxInfo(null);
    };

    render() {
        const isHidden = this.props.hidden || false;
        const { userMailboxWrapper, findControlViewState } = store;
        return (
            <Dialog
                hidden={isHidden}
                isBlocking={true}
                onDismiss={this.closeDialog}
                containerClassName={styles.userVoiceNpsDialog}
                dialogContentProps={{
                    title: this.props.title,
                    styles: this.getContextStyle,
                    subText: this.props.subTitle,
                    type: DialogType.normal,
                }}>
                {!userMailboxWrapper && (
                    <FindPeopleControl
                        ref={ref => {
                            this.peoplePicker = ref;
                        }}
                        onItemSelected={this.onPersonSelected}
                        focusAutomatically={true}
                        viewState={findControlViewState}
                        className={styles.textInputPeoplePicker}
                        openPickerAutomatically={false}
                    />
                )}
                {userMailboxWrapper && (
                    <PeoplePickerPersona
                        removePersonCallback={this.removePerson}
                        userMailboxWrapper={userMailboxWrapper}
                    />
                )}
                <DialogFooter>
                    <PrimaryButton
                        disabled={!userMailboxWrapper}
                        onClick={this.onAddClick}
                        text={strings.addButtonTextForPeoplePickerDialog}
                    />
                    <DefaultButton
                        onClick={this.closeDialog}
                        text={strings.cancelButtonTextForPeoplePickerDialog}
                    />
                </DialogFooter>
            </Dialog>
        );
    }
}
